import http from '@/plugins/http';
// import AccountTransformer from '../../transformers/account';

export default (userInfo, userCompany) => new Promise((res, rej) => {
  const updateUser = new FormData();
  // USER INFORMATION
  if (userInfo.socialToken) {
    updateUser.append('customer_user_full_api[socialToken]', userInfo.socialToken);
  }
  updateUser.append('customer_user_full_api[email]', userInfo.email);
  updateUser.append('customer_user_full_api[countryCode]', 'FR');
  updateUser.append('customer_user_full_api[firstname]', userInfo.firstname);
  updateUser.append('customer_user_full_api[lastname]', userInfo.lastname);
  updateUser.append('customer_user_full_api[phone]', userInfo.phone);
  updateUser.append('customer_user_full_api[gender]', userInfo.gender);
  updateUser.append('customer_user_full_api[origin]', userInfo.origin);
  updateUser.append('customer_user_full_api[jobPosition]', userInfo.post ? userInfo.post : '');
  updateUser.append('customer_user_full_api[plainPassword]', userInfo.password);
  updateUser.append('customer_user_full_api[main_picture]', userInfo.avatarUrl);

  if (userInfo.authMethod) {
    updateUser.append('customer_user_full_api[socialConnect][]', userInfo.authMethod);
  }

  // CUSTOMER ACCOUNT INFORMATION
  updateUser.append('customer_user_full_api[customer][name]', userCompany.name);
  updateUser.append('customer_user_full_api[customer][companySize]', userCompany.size);
  updateUser.append('customer_user_full_api[customer][businessSector]', userCompany.activity);
  updateUser.append('customer_user_full_api[customer][description]', userCompany.description ? userCompany.description : '');
  updateUser.append('customer_user_full_api[customer][logo]', userCompany.avatarUrl);
  updateUser.append('customer_user_full_api[customer][currency]', 'EUR');
  updateUser.append('customer_user_full_api[customer][howKnowUs]', userInfo.origin);

  updateUser.append('customer_user_full_api[customer][billingAddress][company]', userCompany.name);
  updateUser.append('customer_user_full_api[customer][billingAddress][street]', userCompany.street);
  updateUser.append('customer_user_full_api[customer][billingAddress][city]', userCompany.city);
  updateUser.append('customer_user_full_api[customer][billingAddress][zip_code]', userCompany.postalcode);
  updateUser.append('customer_user_full_api[customer][countryCode]', userCompany.countryCode);
  updateUser.append('customer_user_full_api[customer][billingAddress][countryCode]', userCompany.countryCode);
  updateUser.append('customer_user_full_api[customer][billingAddress][country]', userCompany.country);
  if (userCompany.siret) {
    updateUser.append('customer_user_full_api[customer][siret]', userCompany.siret);
  }
  updateUser.append('customer_user_full_api[customer][accountantEmailList]', userCompany.accountant.email);

  http.post('/v3/users/new/customer_user_full', updateUser)
    .then((data) => {
      res(data.data);
    })
    .catch((error) => {
      rej(error);
    });
});
